import AuthedHeader from '@/components/headers/AuthedHeader.vue'
import PublicHeader from '@/components/headers/PublicHeader.vue'
import IndAnnouncements from '@/views/individual/announcements/index.vue'
import IndDashboard from '@/views/individual/dashboard/index.vue'
import AlreadyPay from '@/views/individual/draft/AlreadyPay.vue'
import EidExceptionRequests from '@/views/individual/draft/EidExceptionRequests.vue'
import EidExceptionRequestsView from '@/views/individual/draft/EidExceptionRequestsView.vue'
import PaymentDetails from '@/views/individual/draft/PaymentDetails.vue'
import DraftReadyToPayment from '@/views/individual/draft/ReadyToPayment.vue'
import DraftRequests from '@/views/individual/draft/index.vue'
import MultiplePay from '@/views/individual/draft/multiple-pay/index.vue'
import FamilyMembers from '@/views/individual/family-members/index.vue'
import FeesAndDepositsRefundDeposits from '@/views/individual/fees-deposits-refund/Deposits.vue'
import FeesDepositsRefundMain from '@/views/individual/fees-deposits-refund/Main.vue'
import FeesAndDepositsRefundRefundStatistics from '@/views/individual/fees-deposits-refund/RefundStatus.vue'
import FeesAndDepositsRefundRejected from '@/views/individual/fees-deposits-refund/Rejected.vue'
import IndMyRequests from '@/views/individual/my-requests/index.vue'
import IndReturnedRequests from '@/views/individual/returned-request/index.vue'
import IndRouter from '@/views/individual/router.vue'
import ResidencyView from '@/views/individual/sponsored/ResidencyView.vue'
import SponsoredFiles from '@/views/individual/sponsored/SponsoredFiles.vue'
import VisaView from '@/views/individual/sponsored/VisaView.vue'
import SponsoredRequests from '@/views/individual/sponsored/index.vue'
import TicketInfo from '@/views/individual/ticket/index.vue'
import IndForgetPassword from '@/views/individuals/ForgotPassword/index.vue'
import RegisterIndividualsGcc from '@/views/individuals/onboarding/OnboardGcc.vue'
import RegisterIndividualsUaeVisa from '@/views/individuals/onboarding/OnboardVisa.vue'
import RegisterIndividualsEid from '@/views/individuals/onboarding/eid/index.vue'
import RegisterIndividuals from '@/views/individuals/register.vue'

export default [
  {
    path: '/individuals',
    redirect: '/individuals/registration'
  },
  {
    path: '/individuals/registration',
    name: 'RegisterIndividuals',
    components: {
      default: RegisterIndividuals,
      navbar: PublicHeader
    }
  },
  {
    path: '/individuals/registration/eid',
    name: 'RegisterIndividualsEid',
    components: {
      default: RegisterIndividualsEid,
      navbar: PublicHeader
    }
  },
  {
    path: '/individuals/registration/uae-visa',
    name: 'RegisterIndividualsUaeVisa',
    components: {
      default: RegisterIndividualsUaeVisa,
      navbar: PublicHeader
    }
  },
  {
    path: '/individuals/registration/gcc',
    name: 'RegisterIndividualsGcc',
    components: {
      default: RegisterIndividualsGcc,
      navbar: PublicHeader
    }
  },
  {
    path: '/individuals/forgot-password',
    name: 'IndForgetPassword',
    meta: {
      breadcrumb: {
        label: 'forgetPassword'
      }
    },
    components: {
      default: IndForgetPassword,
      navbar: PublicHeader
    }
  },

  // authenticated
  {
    path: '/individual',
    name: 'IndLanding',
    meta: { needsAuth: true },
    components: {
      navbar: AuthedHeader,
      default: IndRouter
    },
    children: [
      {
        path: '',
        name: 'IndDashboard',
        component: IndDashboard
      },
      {
        path: '/my-requests',
        name: 'IndMyRequests',
        components: {
          default: IndMyRequests
        }
      },
      {
        path: '/residencyView',
        name: 'ResidencyView',
        components: {
          default: ResidencyView
        }
      },
      {
        path: '/visaView',
        name: 'VisaView',
        components: {
          default: VisaView
        }
      },
      {
        path: '/sponsoredFiles',
        name: 'SponsoredFiles',
        components: {
          default: SponsoredFiles
        }
      },
      {
        path: '/my-companies',
        components: {
          default: () => import('@/views/individual/my-companies/router.vue')
        },
        children: [
          {
            path: '',
            name: 'IndMyCompanies',
            components: {
              default: () => import('@/views/individual/my-companies/landing/index.vue')
            }
          },
          {
            path: 'requests',
            name: 'IndMyCompanyRequests',
            components: {
              default: () => import('@/views/individual/my-companies/my-requests/index.vue')
            }
          }
        ]
      },
      {
        path: '/my-requests/returned',
        name: 'IndReturnedRequests',
        components: {
          default: IndReturnedRequests
        }
      },
      {
        path: '/individual/sponsored',
        redirect: '/individual/sponsored/main'
      },
      {
        path: '/individual/sponsored/canceled-files',
        name: 'CanceledRequests',
        components: {
          default: SponsoredRequests
        }
      },
      {
        path: '/individual/sponsored/old-sponsored',
        name: 'OldSponsored',
        components: {
          default: SponsoredRequests
        }
      },
      {
        path: '/individual/sponsored/escape-available',
        name: 'EscapeAvailable',
        components: {
          default: SponsoredRequests
        }
      },
      {
        path: '/individual/sponsored/active-leave-permits',
        name: 'ActiveLeavePermits',
        components: {
          default: SponsoredRequests
        }
      },
      {
        path: '/individual/sponsored/visas-relatives-friends',
        name: 'visasRelativesFriends',
        components: {
          default: SponsoredRequests
        }
      },
      {
        path: 'family-members',
        name: 'IndFamilyMembers',
        components: {
          default: FamilyMembers
        }
      },
      {
        path: '/individual/sponsored/main',
        name: 'IndSponsoredRequests',
        components: {
          default: SponsoredRequests
        }
      },
      {
        path: '/ticket',
        name: 'TicketComplainInfo',
        components: {
          default: TicketInfo
        }
      },
      {
        path: '/drafts',
        name: 'IndDraftRequests',
        components: {
          navbar: AuthedHeader,
          default: DraftRequests
        }
      },
      {
        path: '/requests-for-payment',
        name: 'draftReadyToPayment',
        components: {
          default: DraftReadyToPayment
        }
      },
      {
        path: 'announcements',
        name: 'IndAnnouncements',
        components: {
          default: IndAnnouncements
        }
      },
      {
        path: '/eid-exception-requests',
        name: 'eidExceptionRequests',
        components: {
          default: EidExceptionRequests
        }
      },
      {
        path: '/eid-exception-requests-view/:id',
        name: 'eidExceptionRequestsView',
        components: {
          default: EidExceptionRequestsView
        }
      },

      {
        path: '/multiplePayment',
        name: 'multiplePayment',
        components: {
          default: MultiplePay
        }
      },
      {
        path: '/payments',
        name: 'payments',
        components: {
          default: AlreadyPay
        }
      },
      {
        path: '/payment-details/:id',
        name: 'paymentDetails',
        component: PaymentDetails
      },
      {
        path: '/fees-and-deposits-refund',
        components: {
          default: FeesDepositsRefundMain
        },
        children: [
          {
            path: '',
            name: 'FeesAndDepositsRefund',
            redirect: '/fees-and-deposits-refund/rejected'
          },
          {
            path: 'rejected',
            name: 'FeesAndDepositsRefundRejected',
            component: FeesAndDepositsRefundRejected
          },
          {
            path: 'deposits',
            name: 'FeesAndDepositsRefundDeposits',
            component: FeesAndDepositsRefundDeposits
          },
          {
            path: 'refund-statistics',
            name: 'FeesAndDepositsRefundRefundStatistics',
            component: FeesAndDepositsRefundRefundStatistics
          }
        ]
      }
    ]
  }
]
